import axios from "axios";
import { smartsightAPI } from "../constants/defaultValues";
import jwt from "jsonwebtoken";
import store from "../redux/store";
import { PASSWORD_EXPIRED } from "../redux/actions";
import { VIEW_ONLY_ERROR } from "./accessControl";
import { NotificationManager } from "../components/common/react-notifications";

const apiAuth = axios.create({
  baseURL: smartsightAPI,
});

const requestHandler = async (request) => {
  // Modify request here
  let token = localStorage.getItem("jwt");
  
  // Fallback to sessionStorage if localStorage doesn't have the token
  if (!token) {
    token = sessionStorage.getItem("jwt");
  }

  var decodedToken = jwt.decode(token, { complete: true });

  var exdate = new Date().getTime() / 1000;
  let isExpired = false;
  if (decodedToken === null) {
    isExpired = true;
  } else {
    if (decodedToken.payload.exp < exdate) isExpired = true;
  }

  if (isExpired) {
    console.log("is expired");
    let refreshToken = localStorage.getItem("jwtRefresh");
    if (!refreshToken) {
      refreshToken = sessionStorage.getItem("jwtRefresh");
    }
    
    const res = await axios.post(smartsightAPI + "/api/token/refresh/", {
      refresh: refreshToken,
    });
    
    // Store new access token in both locations
    localStorage.setItem("jwt", res.data.access);
    sessionStorage.setItem("jwt", res.data.access);
    
    request.headers["Authorization"] = "Bearer " + res.data.access;
    return request;
  } else {
    request.headers["Authorization"] = "Bearer " + token;
    return request;
  }
};

apiAuth.interceptors.request.use(async (request) => requestHandler(request));

// Response interceptor to catch 403 PASSWORD_EXPIRED from middleware
apiAuth.interceptors.response.use(
  (response) => response,
  (error) => {
    // View-only users: any write is blocked server-side with
    // 403 VIEW_ONLY_ACCESS. Show a clear message and keep the promise rejected
    // so calling code does not treat it as a success. Match on the `error`
    // field, not the 403 status alone — 403 is also used for password expiry
    // and insufficient permissions, which have their own handling.
    if (
      error.response?.status === 403 &&
      error.response?.data?.error === VIEW_ONLY_ERROR
    ) {
      const message =
        error.response?.data?.message ||
        "Your account has view-only access. You are not allowed to create, update or delete data.";
      NotificationManager.warning(message, "View-only access", 4000, null, null, "");
      return Promise.reject(error);
    }

    if (
      error.response?.status === 403 &&
      error.response?.data?.error === "PASSWORD_EXPIRED"
    ) {
      // Force show the password reset modal
      store.dispatch({
        type: PASSWORD_EXPIRED,
        payload: {
          reason: error.response.data.force_reset ? "admin" : "expired",
          daysRemaining: 0,
        },
      });

      // Reject with a specific flag so calling code knows not to show generic errors
      const passwordExpiredError = new Error("PASSWORD_EXPIRED");
      passwordExpiredError.isPasswordExpired = true;
      return Promise.reject(passwordExpiredError);
    }

    return Promise.reject(error);
  }
);

export default apiAuth;
